import React, { FC, ReactNode } from 'react';

import styles from './styles.module.scss';

type Props = {
  children: ReactNode;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
};

const Toggle: FC<Props> = ({ children, isActive = false, onClick, disabled = false }) => {
  return (
    <div
      className={`${styles.toggleBlock} ${
        isActive && styles.toggleBlockActive
      } ${disabled ? styles.disabled : ''}`}
      onClick={onClick}
    >
      <div className={styles.toggle} />
      <div className={styles.toggleText}>{children}</div>
    </div>
  );
};

export default Toggle;
